import styled from 'styled-components'

export const MainScroll = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: auto;
  padding: 0;
  position: relative;
  z-index: 1;
  margin-top: 65px;
`
